// extracted by mini-css-extract-plugin
module.exports = {"header":"LoginHeader_header__28eqp","active":"LoginHeader_active__6twvq","inactive":"LoginHeader_inactive__1Xgbt"};